import { render } from "./BaseLabel.vue?vue&type=template&id=60ea3e1e"
import script from "./BaseLabel.vue?vue&type=script&lang=ts"
export * from "./BaseLabel.vue?vue&type=script&lang=ts"
script.render = render

export default script